import { render } from "./WaMessages.vue?vue&type=template&id=11edb0c6"
import script from "./WaMessages.vue?vue&type=script&lang=js"
export * from "./WaMessages.vue?vue&type=script&lang=js"

import "./WaMessages.vue?vue&type=style&index=0&id=11edb0c6&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__